export default "__VITE_ASSET__0ce52b3a__"